import React, { useState } from "react";
const DownloadModal = ({ onClose, onDownload }) => {
  const [choice, setChoice] = useState("current");

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 1000,
        background: "rgba(0,0,0,0.45)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          borderRadius: 12,
          border: "1px solid #e5e7eb",
          padding: "1.5rem 1.75rem",
          width: 420,
          maxWidth: "90vw",
        }}
      >
        <p style={{ fontSize: 15, fontWeight: 500, margin: "0 0 4px" }}>
          Download Tenders
        </p>
        <p style={{ fontSize: 13, color: "#6b7280", margin: "0 0 1.25rem" }}>
          What would you like to export?
        </p>

        {[
          {
            value: "current",
            label: "Current tab only",
            desc: "Download only the tenders visible in this tab",
          },
          {
            value: "all",
            label: "All tenders (New → Bid Preparation Pipeline)",
            desc: "One Excel file with all tabs, each as a separate sheet",
          },
        ].map(({ value, label, desc }) => (
          <label
            key={value}
            onClick={() => setChoice(value)}
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: 10,
              cursor: "pointer",
              padding: "12px 14px",
              marginBottom: 10,
              border: `1px solid ${choice === value ? "#93c5fd" : "#e5e7eb"}`,
              borderRadius: 8,
              background: choice === value ? "#eff6ff" : "transparent",
              transition: "all 0.15s",
            }}
          >
            <input
              type="radio"
              name="dltype"
              checked={choice === value}
              onChange={() => setChoice(value)}
              style={{ marginTop: 3, accentColor: "#2563eb" }}
            />
            <div>
              <p style={{ fontSize: 14, fontWeight: 500, margin: "0 0 3px" }}>
                {label}
              </p>
              <p style={{ fontSize: 12, color: "#6b7280", margin: 0 }}>
                {desc}
              </p>
            </div>
          </label>
        ))}

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 8,
            marginTop: 8,
          }}
        >
          <button
            onClick={onClose}
            style={{
              fontSize: 13,
              padding: "7px 16px",
              borderRadius: 8,
              border: "1px solid #e5e7eb",
              background: "transparent",
              cursor: "pointer",
              color: "#374151",
            }}
          >
            Cancel
          </button>
          <button
            onClick={() => {
              onDownload(choice);
              onClose();
            }}
            style={{
              fontSize: 13,
              padding: "7px 16px",
              borderRadius: 8,
              border: "none",
              background: "#2576bc",
              color: "#fff",
              fontWeight: 500,
              cursor: "pointer",
            }}
          >
            Download
          </button>
        </div>
      </div>
    </div>
  );
};
export default DownloadModal;
